import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {setBodyId} from '../../../dom';

import {SmsSettings} from '../../inbox/sms';
import {PageContainer, PageTitleBar} from '../../layout';

type Props = ContextRouter;

/**
 * Allows the SMS settings page to render as a complete page outside of the setup context.
 */
export function SmsSettingsPageStandalone(props: Props) {
    setBodyId('sms-settings');

    return (
        <PageContainer
            title='SMS settings'
            pageTitleBar={
                <PageTitleBar
                    title='SMS settings'
                    subheaderPrimaryText='Add/register a phone number, view registration status, and update messaging preferences'
                />
            }
            whiteBackground={true}
            noPadding={true}
        >
            <SmsSettings {...props} startedFrom='marketing' />
        </PageContainer>
    );
}
